module.exports = __webpack_public_path__ + "img/symbol_black.1c964e48.svg";